<script setup>
import _ from 'lodash'
import { h, computed } from 'vue'
import DataTable from '@/components/ui/data-table/DataTable.vue'
import DataTableSortableColumnHeader from '@/components/ui/data-table/DataTableSortableColumnHeader.vue'
import InterestInfoCell from './creator-interests/InterestInfoCell.vue'

const props = defineProps({
    semanticInterests: {
        type: Array,
        required: true,
    },
})

const interestsList = computed(() => {
    const items = _.reduce(
        props.semanticInterests,
        (results, item) => {

            const sortedInterests = _.orderBy(item.interests, 'strength_rating',  'desc')

            results.push({
                interest: item.semantic_group,
                type: 'primary',
                icon: sortedInterests[0].emoji,
                affinity: sortedInterests[0].strength_rating,
                reason: sortedInterests[0].reason,
            })

            return results
        },
        [],
    )

    return _.orderBy(items, ['affinity'], ['desc'])
})

const toolbar = {
    placeholder: 'Filter interests...',
    columnToFilter: 'interest',
}

const columns = [
    {
        accessorKey: 'interest',
        meta: {
            title: 'Interest',
        },
        header: ({ column }) => h(DataTableSortableColumnHeader, { column, title: column.columnDef.meta.title }),
        cell: ({ row }) => {
            return h(InterestInfoCell, { data: row.original })
        },
        class: 'grow',
    },
]
</script>

<template>
    <DataTable
        :columns="columns"
        :data="interestsList"
        :toolbar="toolbar"
        table-cell-class="py-3 px-3 text-sm"
        preferences-id="creator-interests"
    />
</template>
